import { render, staticRenderFns } from "./SmallAddOnEl.vue?vue&type=template&id=de76becc&scoped=true&"
import script from "./SmallAddOnEl.vue?vue&type=script&lang=ts&"
export * from "./SmallAddOnEl.vue?vue&type=script&lang=ts&"
import style0 from "./SmallAddOnEl.vue?vue&type=style&index=0&id=de76becc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de76becc",
  null
  
)

export default component.exports